module.exports = __webpack_public_path__ + "static/media/City.de426777.svg";